import { StackNavigationOptions } from '@react-navigation/stack';

// Define the colors type if Theme is not available
type ThemeColors = {
  background: string;
  border: string;
  text: string;
};

export const getStackScreenOptions = (colors: ThemeColors): StackNavigationOptions => ({
  headerStyle: {
    backgroundColor: colors.background,
    elevation: 0,
    shadowOpacity: 0,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  headerTintColor: colors.text,
  cardStyle: { 
    backgroundColor: colors.background,
    flex: 1  // Ensure screens take full height for proper scrolling on web
  },
  headerBackTitle: ' ',
  headerBackTitleVisible: false,
});
